import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LabOSTopbar } from './lib/labos';
import { AppHeader } from './components/layout/AppHeader';
import { AppSidebar } from './components/layout/AppSidebar';
import Topics from './pages/Topics';
import TopicWorkspace from './pages/TopicWorkspace';
import EventBank from './pages/EventBank';
import ContextRepository from './pages/ContextRepository';
import HowItWorks from './pages/HowItWorks';
import Schema from './pages/Schema';

function App() {
  return (
    <BrowserRouter>
      <div className="flex h-screen flex-col">
        <LabOSTopbar appName="Story Engine Liquid Content Simulator" accentColor="#8b5cf6" />
        <AppHeader />
        <div className="flex min-h-0 flex-1">
          <AppSidebar />
          <main className="min-w-0 flex-1 overflow-y-auto bg-muted">
            <Routes>
              <Route path="/" element={<Topics />} />
              <Route path="/topics/:id" element={<TopicWorkspace />} />
              <Route path="/event-bank" element={<EventBank />} />
              <Route path="/context-repository" element={<ContextRepository />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/schema" element={<Schema />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
